export default "__VITE_PUBLIC_ASSET__3ca79de5__"